var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',[_vm._v("版权所有 云上星牛（海南）娱乐有限公司")]),_c('div',{staticClass:"mt-2"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn","target":"_blank"}},[_vm._v("琼ICP备2022001602号")])])])
}]

export { render, staticRenderFns }